import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { IssueToolbar } from "@/features/issues/components/issue-toolbar"
import { IssuesTable } from "@/features/issues/components/issues-table"
import { RaiseIssueDialog } from "@/features/issues/components/raise-issue-dialog"
import { issueFilters, issueSearchSchema } from "@/features/issues/issue-search"
import { issueQueries } from "@/queries/issues"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/issues/"
)({
  validateSearch: issueSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureQueryData(
      issueQueries.list(
        issueFilters(deps, { individual_id: params.individualId })
      )
    ),
  component: IndividualIssuesPage,
})

function IndividualIssuesPage() {
  const { individualId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader
        title="Issues"
        actions={
          <RaiseIssueDialog
            subject={{ type: "individual", id: individualId }}
          />
        }
      />
      <section className="flex flex-col gap-4">
        <IssueToolbar
          search={search}
          onSearchChange={(patch) => {
            void navigate({
              replace: true,
              search: (current) => ({ ...current, ...patch }),
            })
          }}
        />
        <IssuesTable
          filters={issueFilters(search, { individual_id: individualId })}
          showSubject={false}
          onPageChange={(page) => {
            void navigate({ search: (current) => ({ ...current, page }) })
          }}
        />
      </section>
    </>
  )
}
